import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { firestore } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import SEO from "./SEO";

/* ---------- Layout ---------- */

const Page = styled.main`
  min-height: 70vh;
  padding: 40px 18px;
  background: radial-gradient(1200px 400px at 20% 0%, rgba(15, 118, 110, 0.10), transparent 55%),
    radial-gradient(900px 360px at 90% 10%, rgba(195, 122, 71, 0.14), transparent 55%),
    #f7fafc;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const Hero = styled.header`
  background: #fff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 18px 55px rgba(0, 0, 0, 0.08);
  border-radius: 22px;
  padding: 22px;
  margin-bottom: 18px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: clamp(24px, 3vw, 44px);
  color: #111827;
  font-weight: 950;
  line-height: 1.12;
`;

const Subtitle = styled.p`
  margin: 10px 0 0;
  color: #6b7280;
  font-weight: 800;
  line-height: 1.6;
`;

/* ---------- Card ---------- */

const Card = styled.section`
  background: #fff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 14px 44px rgba(0, 0, 0, 0.07);
  border-radius: 22px;
  overflow: hidden;
`;

const CardBody = styled.div`
  padding: 18px;

  @media (min-width: 900px) {
    padding: 22px;
  }
`;

const RichText = styled.div`
  color: #374151;
  font-size: 15.5px;
  line-height: 1.9;

  p {
    margin: 12px 0;
  }

  h2,
  h3 {
    margin: 18px 0 10px;
    color: #111827;
    line-height: 1.2;
  }

  ul,
  ol {
    margin: 12px 0 12px 18px;
  }

  a {
    color: #0f766e;
    font-weight: 950;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 14px 0;
    overflow: hidden;
    border-radius: 14px;
    border: 1px solid #e5e7eb;
  }

  th,
  td {
    padding: 10px 12px;
    border-bottom: 1px solid #eef2f7;
    text-align: left;
  }

  th {
    background: #f9fafb;
    font-weight: 950;
    color: #111827;
  }
`;

const Loading = styled.div`
  padding: 16px 18px;
  color: #6b7280;
  font-weight: 900;
`;

const Empty = styled.div`
  padding: 16px 18px;
  color: #6b7280;
  font-weight: 900;
`;

/* ---------- Component ---------- */

const Avgift = () => {
  const [avgift, setAvgift] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAvgift = async () => {
      try {
        setLoading(true);
        const ref = doc(firestore, "avgifter", "general");
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setAvgift(snap.data().avgift || "");
        } else {
          setAvgift("");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAvgift();
  }, []);

  return (
    <>
      <SEO
        title="Avgifter"
        description="Avgifter och medlemsinformation för Hofors BGK."
        keywords="avgifter, medlemskap, hofors bgk"
      />

      <Page>
        <Container>
          <Hero>
            <Title>Avgifter</Title>
            <Subtitle>Här hittar du aktuella avgifter och information.</Subtitle>
          </Hero>

          <Card>
            {loading ? (
              <Loading>Laddar avgifter…</Loading>
            ) : avgift ? (
              <CardBody>
                <RichText dangerouslySetInnerHTML={{ __html: avgift }} />
              </CardBody>
            ) : (
              <Empty>Inga avgifter tillgängliga just nu.</Empty>
            )}
          </Card>
        </Container>
      </Page>
    </>
  );
};

export default Avgift;
